import { PropTypes } from 'prop-types';

import { Container, LargeColumn, SmallColumn } from './TwoColumnLayout.style';
import { RootLayout } from '../RootLayout';

function TwoColumnLayout({ children, ...delegated }) {
  return (
    <RootLayout>
      <Container {...delegated}>{children}</Container>
    </RootLayout>
  );
}

TwoColumnLayout.SmallColumn = SmallColumn;
TwoColumnLayout.LargeColumn = LargeColumn;

TwoColumnLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default TwoColumnLayout;
